export default __webpack_public_path__ + "static/media/down-arrow-svgrepo-com.088b038d.svg";